import React from 'react';

import {
    useFormControl,
    useFormGroup,
    useManageTemplateForm,
} from '../../../utils/form.utils';
import { requiredValidator } from '../../../utils/validator.utils';
import { TagItem } from '../../../shared/types';
import ManageTemplate, {
    ManageTemplateInstance,
} from '../../ui/ManageTemplate';
import { ADD_TAG, DELETE_TAG, EDIT_TAG, TAG } from '../../../gql/tags';
import FormTextArea from '../../ui/form/FormTextArea';
import FormTextField from '../../ui/form/FormTextField';
import { Box } from '@mui/material';
import { baseUrls } from '../../../utils/baseUrls.utils';
import { sanitizeRouteId } from '../../../utils/route-params.utils';

import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import Loader from 'components/ui/LoadingIndicator';
import ContainerBox from 'components/ui/ContainerBox';
const returnListUrl = baseUrls.publisher.tags.list;

const TagAddEdit = (): JSX.Element => {
    const { _id: routeId } = useParams<{ _id?: string }>();
    const _id = sanitizeRouteId(routeId);
    const form = useFormGroup({
        name: useFormControl<string>('', [requiredValidator]),
        description: useFormControl<string>('', [requiredValidator]),
    });

    const { loading, data } = useQuery<{ document: TagItem }>(TAG, {
        skip: !_id,
        fetchPolicy: 'network-only',
        variables: { id: _id },
        onCompleted: (data) => {
            const document = data?.document;
            if (document) {
                form.name.setInitialValue(document.name);
                form.description.setInitialValue(document.description);
            }
        },
    });

    const {
        isNew,
        formMessage,
        formBusy,
        onSubmit,
        onCancel,
        onDelete,
        onAlertBoxClose,
    } = useManageTemplateForm(
        ManageTemplateInstance.Tag,
        form,
        data?.document,
        ADD_TAG,
        EDIT_TAG,
        DELETE_TAG,
        returnListUrl
    );

    if (loading) return <Loader />;

    return (
        <ContainerBox>
            <Box sx={{ flex: 1, flexDirection: 'column', maxWidth: 1200 }}>
                <ManageTemplate
                    dialogMessage={
                        <>
                            You are about to delete the tag
                            <strong> {form.name.value}</strong>. This action
                            cannot be undone, so you must be sure and confirm.
                        </>
                    }
                    onDelete={() => onDelete(form.name.value)}
                    pathArea={'Tags'}
                    returnUrl={returnListUrl}
                    templateInstance={ManageTemplateInstance.Tag}
                    isNew={isNew}
                    formMessage={formMessage}
                    formBusy={formBusy}
                    onCancel={onCancel}
                    onSubmit={(ev) =>
                        onSubmit(ev, {
                            ...form.value,
                            version: !isNew
                                ? data?.document?.version
                                : undefined,
                        })
                    }
                    onAlertBoxClose={onAlertBoxClose}
                >
                    <FormTextField
                        id="tag-name-input"
                        label="Name"
                        field={form.name}
                        charsLimit={50}
                    />
                    <FormTextArea
                        id={'tag-description-textarea'}
                        field={form.description}
                        charsLimit={500}
                    />
                </ManageTemplate>
            </Box>
        </ContainerBox>
    );
};

export default TagAddEdit;
